import { getUserAuthScopes, type UserLike } from '@/client/services/user'

import type { UserAuthScope } from '../userRole/types'
import { type AuthScope, isWorldsAuthScope } from '../worlds/authScopes'

type GenericHasUserAuthScopeArgs = [user: UserLike, authScope: UserAuthScope]
type WorldsHasUserAuthScopeArgs = [user: UserLike, authScope: AuthScope, worldId: number | null]

// We use function overload to make sure the worldId is provided when the authScope
// in question is a Worlds auth scope, e.g.
// hasUserAuthScope(user, 'session:update') vs. hasUserAuthScope(user, 'world:post:create', 1)
function hasUserAuthScope(...args: GenericHasUserAuthScopeArgs): boolean
function hasUserAuthScope(...args: WorldsHasUserAuthScopeArgs): boolean
function hasUserAuthScope(
  ...args: GenericHasUserAuthScopeArgs | WorldsHasUserAuthScopeArgs
): boolean {
  const [user, authScope, worldId] = args

  const hasAuthScopeGeneric = getUserAuthScopes(user).includes(authScope)

  if (hasAuthScopeGeneric) {
    return true
  }

  let hasAuthScopeWorlds = false
  if (isWorldsAuthScope(authScope)) {
    if (worldId == null) {
      hasAuthScopeWorlds = Object.values(user.worlds ?? {}).some(({ authScopes }) =>
        authScopes.includes(authScope)
      )
    } else {
      const authScopesForWorld = user.worlds?.[worldId]?.authScopes ?? []
      hasAuthScopeWorlds = authScopesForWorld.includes(authScope)
    }
  }

  return hasAuthScopeWorlds
}

export default hasUserAuthScope
